import React from 'react'
import { getActiveUser } from '../../redux'
import { hasRole } from '../../helpers/permissionsHelper'
import { UserRoles } from '../../model'
import { fetchTanksListItems, fetchTanksListItemsForUser } from './tanks.service'
import { TanksList } from './components/tanksList/tanksList'

export interface TanksPageProps {}

export const TanksPage: React.FC<TanksPageProps> = () => {
  const repsolUser = hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) //58035
    //hasRole(UserRoles.TANKS_REPSOL_GESTIONADO) || hasRole(UserRoles.TANKS_REPSOL_NO_GESTIONADO)

  const fetchService = repsolUser ? fetchTanksListItemsForUser : fetchTanksListItems

  return <TanksList fetchService={fetchService} />
}
